module.exports = __webpack_public_path__ + "static/media/jiaoyi2.12993411.png";